import { auth } from '../../../firebase';

/**
 * Action Creators - Pure functions
 */
export const logoutStart = () => ({
    type: 'LOGOUT_START'
});

export const logoutSuccess = () => ({
    type: 'LOGOUT_SUCCESS'
});

export const logoutFailure = (error) => ({
    type: 'LOGOUT_FAILURE',
    payload: error
});

/**
 * handleInactivityLogout - לוגיקה להתנתקות בגלל חוסר פעילות
 * מקבלת dispatch ומבצעת את כל התהליך
 */
export const handleInactivityLogout = async (dispatch) => {
    try {
        // LOGOUT_START
        dispatch(logoutStart());

        console.log('👋 Logging out user due to inactivity...');

        // התנתקות מ-Firebase
        await auth.signOut();

        // ניקוי localStorage
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('dashboard_')) {
                localStorage.removeItem(key);
            }
        });

        // LOGOUT_SUCCESS
        dispatch(logoutSuccess());

        console.log('✅ User logged out successfully due to inactivity');

        // ניווט לדף הבית
        window.location.href = '/';

        return { success: true };
    } catch (error) {
        console.error('❌ Error logging out:', error);

        // LOGOUT_FAILURE
        dispatch(logoutFailure(error.message));

        throw error;
    }
};
